import {IResponse} from '../../common/model/Core.model'
import {environment} from '../../util/Environment'
import {apiSlice} from '../store/Api'
import {
  IContractCreateRequestDto,
  IContractUpdateRequestDto,
  IContractDto,
  IContractSearchRequestDto,
} from './Contract.model'
export const contractApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      contractAttachmentSearch: builder.mutation<IResponse, IContractSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.contract}/attachment/search`,
            method: 'POST',
            body,
          }
        },
      }),
      contractAttachmentDeleteById: builder.mutation<void, string>({
        query(id) {
          return {
            url: `${environment.apiUrl.contract}/attachment/${id}`,
            method: 'DELETE',
          }
        },
      }),
      contractSearch: builder.mutation<IResponse, IContractSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.contract}/search`,
            method: 'POST',
            body,
          }
        },
      }),
      contractLoadMore: builder.mutation<IResponse, IContractSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.contract}/search`,
            method: 'POST',
            body,
          }
        },
      }),
      contractGetById: builder.mutation<IContractDto, {id: string; fields?: string}>({
        query(parameters) {
          const queryParams = parameters.fields ? `?fields=${parameters.fields}` : ''
          return {
            url: `${environment.apiUrl.contract}/${parameters.id}` + queryParams,
            method: 'GET',
          }
        },
      }),
      contractCreate: builder.mutation<IContractDto, IContractCreateRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.contract}`,
            method: 'POST',
            body,
          }
        },
      }),
      contractUpdateById: builder.mutation<IContractDto, IContractUpdateRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.contract}/${body.id}`,
            method: 'PATCH',
            body,
          }
        },
      }),
      contractDeleteById: builder.mutation<void, string>({
        query(id) {
          return {
            url: `${environment.apiUrl.contract}/${id}`,
            method: 'DELETE',
          }
        },
      }),
    }
  },
})

export const {
  useContractAttachmentSearchMutation,
  useContractAttachmentDeleteByIdMutation,
  useContractSearchMutation,
  useContractLoadMoreMutation,
  useContractCreateMutation,
  useContractUpdateByIdMutation,
  useContractGetByIdMutation,
  useContractDeleteByIdMutation,
} = contractApi
